import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import { emptyString } from 'utils/constants';

import { get, set } from '@totalsoft/change-tracking-react';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const DocumentSignStateTransitionsComponent = ({ item, documentStates, validation }) => {
  const [t] = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          simpleValue
          value={item.startStatus |> get || emptyString}
          options={documentStates}
          label={t('DocumentSignStateTransitions.StartStatus')}
          valueKey='id'
          labelKey='name'
          onChange={item.startStatus |> set}
          isSearchable
          error={!isValid(validation.startStatus)}
          helperText={getErrors(validation.startStatus)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          simpleValue
          value={item.inProgressStatus |> get || emptyString}
          options={documentStates}
          label={t('DocumentSignStateTransitions.InProgressStatus')}
          valueKey='id'
          labelKey='name'
          onChange={item.inProgressStatus |> set}
          isSearchable
          error={!isValid(validation.inProgressStatus)}
          helperText={getErrors(validation.inProgressStatus)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          simpleValue
          value={item.endStatus |> get || emptyString}
          options={documentStates}
          label={t('DocumentSignStateTransitions.EndStatus')}
          valueKey='id'
          labelKey='name'
          onChange={item.endStatus |> set}
          isSearchable
          error={!isValid(validation.endStatus)}
          helperText={getErrors(validation.endStatus)}
        />
      </Grid>
    </Grid>
  );
};

DocumentSignStateTransitionsComponent.propTypes = {
  item: PropTypes.object.isRequired,
  documentStates: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default DocumentSignStateTransitionsComponent;
